import { register } from "async-ops";
import { callMvcApi } from "../../../../../call-web-api";
import { getDefaultOptions } from "../../../../../utils/fetch";
export const GET_TOTAL_AND_REJECTED_SUBMISSIONS_DATA = "GET_TOTAL_AND_REJECTED_SUBMISSIONS_DATA";

export const service = async (data) => {
    const options: object = {
        url: `/api/EsMD/GetTotalAndRejectedSubmissions/${data.timePeriod}/${data.reviewContractorId}/${data.toggleValue}`,
        method: "GET",
    };
    const response = callMvcApi(options);
    return response;
};

const mockData = () => {
    return [];
};

const mock = () => {
    const promise = new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve(mockData());
        }, 2000);
    });
    return promise;
};


register(GET_TOTAL_AND_REJECTED_SUBMISSIONS_DATA, service, mock);
